// src/pages/HomePage.js
import React, {useEffect,lazy,Suspense,useState} from 'react';
import CenteredSpinner from '../components/spinner';
import Header from '../components/Header';
import Footer from '../components/footer';
import DummySearchPage from '../components/dummySearchBar';
import { useContext } from 'react';
import AuthContext from '../components/authContext';
import Brands from '../components/brands';
import MarqueeExample from '../components/marquee';
import Banner from '../components/banner';

 
const Body = lazy(() => import("../components/body"));

const HomePage = () => {
  const { user, isLoggedIn, logout,isVerified } = useContext(AuthContext);    

  
    return (
        <div> 
            
            <MarqueeExample/>
            <Header />
            <DummySearchPage/>
            <Brands/>
            
            <Suspense fallback = {<div><CenteredSpinner/></div>}>
            <Body /> 
            </Suspense>
            <Footer />
            
        </div>
    );
};

export default HomePage;